var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map-form-btn" },
    [
      _c(
        "v-btn",
        {
          staticClass: "opt-btn",
          attrs: {
            "active-class": "default-class btn-active",
            outline: "",
            small: "",
            fab: "",
            title: _vm.title
          },
          on: {
            click: function($event) {
              return _vm.$emit("clicked")
            }
          }
        },
        [
          _c("v-icon", { attrs: { color: _vm.color } }, [
            _vm._v(_vm._s(_vm.icon))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "btn-legend" }, [_vm._v(_vm._s(_vm.btnText))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-271145d2", { render: render, staticRenderFns: staticRenderFns })
  }
}